import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import i18n from './i18n';
import '../../assests/css/footerStyle.css';
import imageBcra from '../../assests/images/footer/BCRA_logo.svg';
import imageCnv from '../../assests/images/footer/cnv.png';
import imageDataFiscal from '../../assests/images/footer/data-fiscal.png';
import imagePdp from '../../assests/images/footer/pdp.png';
import imageRenaper from '../../assests/images/footer/renaper.svg';
import imageSid from '../../assests/images/footer/sid.png';
import imageFinanceUser from '../../images/infoFinancialUser/usuario_financiero.png';

/* eslint "arrow-body-style": "off" */
const FooterLogos = () => {
  return (
    <Box className="boxFooter">
      <Box className="footerBottom">
        <Typography className="footerCopyright">
          {i18n.footerCopyright.replace('{0}', new Date().getFullYear())}
        </Typography>
        <Box className="gridImages">
          <img src={imageBcra} alt={i18n.footerBcra} className="imageBcra" />
          <img src={imagePdp} alt={i18n.footerPdp} className="imagePdp" />
          <img src={imageSid} alt={i18n.footerSid} className="imageSid" />
          <img src={imageRenaper} alt={i18n.footerRenaper} className="imageRenaper" />
          <img src={imageCnv} alt={i18n.footerCnv} className="imageCnv" />
          <a
            href="https://www.bcra.gob.ar/BCRAyVos/Usuarios_Financieros.asp"
            rel="noopener noreferrer"
            target="_blank"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <img
              src={imageFinanceUser}
              alt={i18n.footerUserInformation}
              className="imageUserInformation"
            />
          </a>
          <img src={imageDataFiscal} alt={i18n.footerDataFiscal} className="imageDataFiscal" />
        </Box>
      </Box>
    </Box>
  );
};

export default FooterLogos;
